import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

/*
buttons: [
{
  title, variant, onClick
}]
*/
function BasicModal({
  title,
  message,
  show,
  close,
  size,
  buttons = [],
  maxHeight = 500,
  borderLess = false,
}) {
  function renderButtons() {
    return buttons.map((button) => {
      return (
        <Button key={button.title} variant={button.variant || "secondary"} onClick={button.onClick}>
          {button.title}
        </Button>
      );
    });
  }

  function showCloseButton() {
    return (
      <Button
        variant="secondary"
        onClick={() => {
          close();
        }}
      >
        Close
      </Button>
    );
  }
  return (
    <Modal show={show} onHide={close} size={size || "lg"}>
      {title ? (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      ) : null}

      <Modal.Body
        style={{
          overflowY: "scroll",
          paddingLeft: borderLess ? 0 : null,
          paddingRight: borderLess ? 0 : null,
        }}
      >
        <div>{message}</div>
      </Modal.Body>

      <Modal.Footer>{buttons?.length > 0 ? renderButtons() : showCloseButton()}</Modal.Footer>
    </Modal>
  );
}

export default BasicModal;
